import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_2 = {
  key: 0,
  class: "text-red"
}
const _hoisted_3 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_4 = { class: "mt-7" }
const _hoisted_5 = {
  key: 0,
  class: "text-red text-center mb-5"
}
const _hoisted_6 = { class: "flex" }

import { reactive, ref } from 'vue';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RenewExpiredPasswordForm',
  props: { accessToken: { type: String, required: true } },
  emits: ['passwordRenewed'],
  setup(__props, { emit: __emit }) {

    const props = __props;
    const emit = __emit;

    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        new_password: '',
        confirm_password: '',
    });
    const formErrors = reactive({
        new_password: '',
        confirm_password: '',
    });
    const accessToken = ref('');

    function validate() {
        let isValid = true;

        formErrors.new_password = '';
        if (!formData.new_password) {
            formErrors.new_password ="Le nouveau mot de passe est requis";
            isValid = false;
        }

        formErrors.confirm_password = '';
        if (!formData.confirm_password) {
            formErrors.confirm_password ="Veuillez confirmer le mot de passe";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            await axios.post(`/backoffice/auth/renew_expired_password`, formData, {
                headers: {
                    Authorization: `Bearer ${props.accessToken}`
                }
            });
            emit("passwordRenewed");
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "font-semibold my-8 text-center" }, [
      _createTextVNode("Renouvellement du mot de passe "),
      _createElementVNode("span", { class: "text-sm text-grey-500" })
    ], -1)),
    _createElementVNode("form", {
      class: "form",
      onSubmit: _withModifiers(onSubmit, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "form-input",
          id: "new_password",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.new_password) = $event))
        }, null, 512), [
          [_vModelText, formData.new_password]
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("label", { for: "new_password" }, [
          _createTextVNode("Nouveau Mot de passe "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1))
      ]),
      (!!formErrors['new_password'])
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(formErrors['new_password']), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "form-input",
          id: "confirm_password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.confirm_password) = $event))
        }, null, 512), [
          [_vModelText, formData.confirm_password]
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("label", { for: "password" }, [
          _createTextVNode("Confirmer Mot de passe "),
          _createElementVNode("b", { class: "color-danger" }, "*")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "submit",
            classesList: 'btn xl s20',
            loading: loading.value
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: "/icons/icon-menu-securite.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Valider", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ], 32)
  ]))
}
}

})